




import Vue from "vue"
import {
  makeActionAfterAuthSuccess,
  makeRedirectPathFromQuery,
  AUTH_REDIRECT_PATH_QUERY_NAME,
} from "~/uiLogics/auth/authExecutor"
import LoadingOverlay, {
  WHITE_BACKGROUND,
} from "~/components/guideline/loading/LoadingOverlay.vue"
import { consumeRefererPath } from "~/uiLogics/webStorage/profileCreationReferer"

export default Vue.extend({
  components: {
    LoadingOverlay,
  },
  computed: {
    backgroundType() {
      return { WHITE_BACKGROUND }
    },
  },
  beforeMount() {
    const actionAfterAuthFailure = () => {
      this.$nuxt.$router.push({ path: "/" })
    }

    this.$clAuth.completeAuthProcess({
      callbackWhenSuccess: this.makeActionAfterAuthSuccess(),
      callbackWhenFailed: actionAfterAuthFailure,
    })
  },
  methods: {
    makeActionAfterAuthSuccess() {
      const refererPath =
        consumeRefererPath() || this.$route.query[AUTH_REDIRECT_PATH_QUERY_NAME]
      const redirectPathInQuery = makeRedirectPathFromQuery(refererPath)
      return makeActionAfterAuthSuccess(this.$nuxt.$router, redirectPathInQuery)
    },
  },
})
